// 天降红包投放位置
export enum Visit {
  Tagless = 1, // 无标签页
  Quality = 72, // 质量首页
}
